import { useMutation } from '@tanstack/react-query'
import axios from 'axios'
import { useSelector } from 'react-redux'
import { CreditCardListResponse } from 'src/models/creditCard.models'
import { PostCreditCardSuccessPayload } from 'src/redux/actions/data/creditCards.actions'
import {
  selectAuthedJsonApiRequestConfig,
  selectAuthedJsonVaultRequestConfig,
} from 'src/redux/selectors/axios.selectors'
import { PostCreditCardRequest } from 'src/requests/postCreditCard.request'

type PostCreditCardV2Request = PostCreditCardRequest & {
  cardholderName: string
  cvc: string
}

// INCOMPLETE TYPE. Only grabbing what we need from here
// for the time being
type PostCreditCardV2Response = {
  creditCard: {
    id: string
  }
}

/**
 * Create a stub credit card to be verified later via PUT and 3DS verification for
 * physical cards
 * @API_TYPE - vgs.paywithextend.com
 * @endpoint POST /creditcardsv2
 * @params options
 */
export function usePostCreditCardV2() {
  const vaultConfig = useSelector(selectAuthedJsonVaultRequestConfig)
  const mutation = useMutation({
    mutationFn: async (body: Partial<PostCreditCardV2Request>) => {
      // Use VGS subdomain instead. Figure out how environments work to do this
      // since the subdomain changes
      const response = await axios.post<Partial<PostCreditCardSuccessPayload>>(
        '/creditcardsv2',
        body,
        vaultConfig,
      )

      return response.data as PostCreditCardV2Response
    },
  })

  return mutation
}

/**
 * @API_TYPE - api.paywithextend.com
 * @returns
 */
export function usePutCreditCardV2() {
  const authedConfig = useSelector(selectAuthedJsonApiRequestConfig)
  const mutation = useMutation({
    mutationFn: async (options: {
      creditCardId: string
      endpoint: 'virtual' | 'physical'
    }) => {
      const { creditCardId, endpoint } = options
      const response = await axios.put(
        `/creditcardsv2/${creditCardId}/${endpoint}`,
        {},
        authedConfig,
      )

      return response.data
    },
  })

  return mutation
}
/**
 * Deactivates a physical card from the Astrada integration feed
 * @returns
 */
export function useDeactivatePhysicalCard() {
  const authedConfig = useSelector(selectAuthedJsonApiRequestConfig)
  const mutation = useMutation({
    mutationFn: async (
      creditCardId: string,
    ): Promise<CreditCardListResponse> => {
      // axios.put was acting weird so putting in this way is working as expected
      const response = await axios.request({
        ...authedConfig,
        method: 'PUT',
        headers: {
          ...authedConfig.headers,
        },
        url: `/creditcardsv2/${creditCardId}/deactivate`,
      })
      const data = response.data

      return data
    },
  })

  return mutation
}
